import { DEPLOYMENT_UPDATE_SELECTED_DEPLOYMENT } from '@/store/mutypes';
import {
  RootState,
  DeploymentState,
  DeployDTO,
  Deployment,
  CreateDeploymentDTO,
  Response,
  BulkUpgradeDTO
} from '@/types';
import { ActionContext } from 'vuex';
import { deploymentSvc } from '@/services';

// initial state
const modState: DeploymentState = {
  selectedDeployment: undefined
};

// getters
const getters = {
  showDeployDialog(state: DeploymentState): boolean {
    return !!state.selectedDeployment;
  }
};

// actions, to handle async call
const actions = {
  async deploy(
    { commit }: ActionContext<DeploymentState, RootState>,
    dto: DeployDTO
  ): Promise<Response> {
    return await deploymentSvc.deploy(dto);
  },
  async createDeployment(
    { commit }: ActionContext<DeploymentState, RootState>,
    dto: CreateDeploymentDTO
  ): Promise<Deployment> {
    return await deploymentSvc.create(dto);
  },
  async bulkUpgrade(
    { commit }: ActionContext<DeploymentState, RootState>,
    dto: BulkUpgradeDTO
  ): Promise<Response> {
    return await deploymentSvc.bulkUpgrade(dto);
  },
  async suspendDeployment(
    { commit }: ActionContext<DeploymentState, RootState>,
    id: string
  ): Promise<Response> {
    return await deploymentSvc.suspendDeployment(id);
  },
  async resumeDeployment(
    { commit }: ActionContext<DeploymentState, RootState>,
    id: string
  ): Promise<Response> {
    return await deploymentSvc.resumeDeployment(id);
  },
  async purgeDeployment(
    { commit }: ActionContext<DeploymentState, RootState>,
    id: string
  ): Promise<Response> {
    return await deploymentSvc.purgeDeployment(id);
  }
};

const mutations = {
  [DEPLOYMENT_UPDATE_SELECTED_DEPLOYMENT](
    state: DeploymentState,
    deployment: Deployment
  ) {
    state.selectedDeployment = deployment;
  }
};

export default {
  state: modState,
  getters,
  actions,
  mutations
};
